declare var require: any;

export class VersionService {
  public getVersion(): string {
    return require('../../../../../../package.json').version;
  }
}
